import _asyncToGenerator from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useCallback } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useAccountsService } from '@restworld/data-services';
import { useAuth } from './use-auth';
var isProd = process.env['NEXT_PUBLIC_APP_ENV'] === 'production';
export var employerUserContactAtom = globalThis.jotaiAtomCache.get("/vercel/path0/libs/feature-authentication/src/hook/use-employer-user-info-query.ts/employerUserContactAtom", atom({}));
employerUserContactAtom.debugLabel = 'employerUserContactAtom';
export var employerUserContactQueryKey = ['employer-user-contact'];
export var useEmployerUserContactQuery = function useEmployerUserContactQuery() {
  var setEmployerUserContact = useSetAtom(employerUserContactAtom);
  var accountServices = useAccountsService();

  var _useAuth = useAuth(),
      user = _useAuth.user;

  var enableApiCall = Boolean(user && (user.type === 'employer' || user.type === 'employer_contact'));
  var router = useRouter(); // Define a callback function to handle switching to the old version of the application

  var switchToOldVersion = useCallback(function (switchToNewVersion) {
    // Get the current path from the router
    var currentPath = router.asPath; // Determine if the user should switch to the old version

    var isSwitchToOldVersion = switchToNewVersion === false; // Check if the current path is within the v2 employer section

    var isCurrentPathEmployer = currentPath.includes('/v2/employer'); // and the current path is within the v2 employer section and isSwitchToOldVersion is true, redirect to the old employer job positions page

    if (isProd && isSwitchToOldVersion && isCurrentPathEmployer) {
      router.push('/employer/job-positions');
    }
  }, [router]);
  var fetchEmployerUserContact = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return accountServices.fetchEmployerUserContact(user === null || user === void 0 ? void 0 : user.id);

          case 2:
            data = _context.sent.data;
            setEmployerUserContact(data);
            switchToOldVersion(data.switch_to_new_version);
            return _context.abrupt("return", data);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [user === null || user === void 0 ? void 0 : user.id, accountServices, setEmployerUserContact, switchToOldVersion]);
  var queryData = useQuery({
    queryKey: employerUserContactQueryKey,
    queryFn: fetchEmployerUserContact,
    enabled: enableApiCall
  });
  return queryData;
};
export var useEmployerUserContactData = function useEmployerUserContactData() {
  return useAtomValue(employerUserContactAtom);
};
export var useEmployerUserInformationLoadingState = function useEmployerUserInformationLoadingState() {
  var _useQueryClient$getQu;

  return ((_useQueryClient$getQu = useQueryClient().getQueryState(employerUserContactQueryKey)) === null || _useQueryClient$getQu === void 0 ? void 0 : _useQueryClient$getQu.status) === 'pending';
};